import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NavItemComponent } from '../nav-item/nav-item.component';
import { INavItem } from '@tnq/shared/types';

@Component({
  selector: 'tnq-nav-list',
  imports: [NavItemComponent],
  templateUrl: './nav-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './nav-list.component.scss',
})
export class NavListComponent {
  navItems = input<INavItem[]>([]);
  isNarrowDisplay = input<boolean>(false);
}
